
export const version = process.env.REACT_APP_WSP_ENV === 'development' ? '0.0.0' : '3.26.4';
